import React, { useContext } from 'react'
import { BsBlockquoteRight } from 'react-icons/bs'
import { EditorContext } from '../../../../../../../components/CanvasEditor/Context/EditorProvider';

const LineHeight = () => {

  const { textEditorOptions, setTextEditorOptions } = useContext(EditorContext);

  const handleChange = (e) => {
    setTextEditorOptions({ ...textEditorOptions, lineHeight: e.target.value });
  }

  return (
    <div className='line-height' data-toggle="tooltip" data-placement="top" title="Line Height">
      <label><BsBlockquoteRight /></label>
      <input type='number' value={textEditorOptions.lineHeight} onChange={handleChange} />
    </div>
  )
}

export default LineHeight